const env = {
  baseApiUrl: "/api" //for local env https://localhost:6001/api 
}

export default env;